import React from 'react';
import { useCookieConsent } from '../contexts/CookieContext';

interface ConsentGuardProps {
  children: React.ReactNode;
  type?: 'analytics' | 'externalMedia';
  title: string;
}

const ConsentGuard: React.FC<ConsentGuardProps> = ({
  children,
  type = 'externalMedia',
  title
}) => {
  const { consent, setShowBanner } = useCookieConsent();

  const hasConsent = consent ? (type === 'analytics' ? consent.analytics : consent.externalMedia) : false;

  if (hasConsent) {
    return <>{children}</>;
  }

  return (
    <div className="my-4 flex flex-col items-center justify-center space-y-4 border border-dashed border-gray-300 bg-gray-50 p-8 text-center">
      <svg aria-hidden="true" className="h-8 w-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
      </svg>
      <div>
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        <p className="mt-1 max-w-md text-sm text-gray-600">
          Dieser Inhalt wird von einem Drittanbieter geladen. Um ihn anzuzeigen, müssen Sie der Verwendung von externen Medien zustimmen.
        </p>
      </div>
      <button
        type="button"
        onClick={() => setShowBanner(true)}
        className="min-h-[44px] bg-blue-600 px-5 text-[15px] font-semibold text-white transition-colors hover:bg-blue-700"
      >
        Einstellungen anpassen
      </button>
    </div>
  );
};

export default ConsentGuard;
